import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "UserFavoriteAltFilled"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.8706 2.25C19.171 2.24975 18.5007 2.53084 18.0106 3.03L17.6273 3.4215L17.2403 3.02925C16.7497 2.53088 16.0796 2.25023 15.3803 2.25023C14.681 2.25023 14.0109 2.53088 13.5203 3.02925C12.4946 4.07612 12.4946 5.75113 13.5203 6.798L17.6273 10.9553L21.7313 6.798C22.7571 5.75113 22.7571 4.07612 21.7313 3.02925C21.2409 2.53018 20.5703 2.24936 19.8706 2.25ZM12 22.5H10.5V18.75C10.4988 17.5079 9.49213 16.5012 8.25 16.5H5.25C4.00787 16.5012 3.00124 17.5079 3 18.75V22.5H1.5V18.75C1.50248 16.68 3.17996 15.0025 5.25 15H8.25C10.32 15.0025 11.9975 16.68 12 18.75V22.5ZM6.75 7.5C7.99264 7.5 9 8.50736 9 9.75C9 10.9926 7.99264 12 6.75 12C5.50736 12 4.5 10.9926 4.5 9.75C4.5 8.50736 5.50736 7.5 6.75 7.5V7.5ZM6.75 6C4.67893 6 3 7.67893 3 9.75C3 11.8211 4.67893 13.5 6.75 13.5C8.82107 13.5 10.5 11.8211 10.5 9.75C10.5 8.75544 10.1049 7.80161 9.40165 7.09835C8.69839 6.39509 7.74456 6 6.75 6V6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/UserFavoriteAltFilled.vue"]]);
